// React Dependencies
import React, { useMemo, useState, useEffect, useRef } from 'react';
// Common Dependencies
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
// Component
import { Form, Row, Col, Modal, Button, Stack } from 'react-bootstrap';
import { TNButton, TNTable } from '@common/components';

import { useFormik } from 'formik';

// datepicker
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// datepicker

// Alert
import { toast } from 'react-toastify';
// Asset
import 'react-confirm-alert/src/react-confirm-alert.css';
// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faCalendar, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import {
  useOwnListPunchInOut,
  useRouteAccessList,
  useDeleteBioMetric,
  useBioMetricSetting,
  useUpdateBioMetric
} from '@hooks';

import CommonSEOTitle from '../../../../../helpers/CommonSEOTitle';
import {
  getAllStoredData,
  getSignleStoredData,
  getStoredDataUsingKey,
  removeStoredData,
  setAllStoredData,
  setSingleStoredData
} from '../../../../../helpers/localStorageHelper';
import { dateFormatCommon, dateFormatManualAdd } from '@helpers';
import Select from 'react-select';

import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import '@assets/scss/components/_own_punch_in_out.scss';

import { useSelector } from 'react-redux';
import { loggedUser } from '../../../../store/features/authSlice';
import { validationSchema } from './AddEditPunchOutValidation';

import viewIcon from '../../../../../assets/images/svg/table-view.svg';
import deleteIcon from '../../../../../assets/images/svg/table-delete.svg';
import editIcon from '../../../../../assets/images/svg/table-edit.svg';
import CloseIcon from '../../../../../assets/images/svg/close.svg';
import '../../../../../assets/scss/components/_new_table.scss';
import DateIcon from '../../../../../assets/images/svg/date-input.svg';
import { setPageMoveToFirstPage } from '../../../../../helpers';
import { onDefaultError } from '../../../../../helpers/commonHelpers';

const ListPage = ({ t, updateSelectedTab, alert }) => {
  const inputRef = useRef(null);
  const toDateRef = useRef(null);

  const storageKey = `hrms_own_punch_in_out_tab_data`;
  useEffect(() => {
    setSingleStoredData('punch_in_out_tab', 'own');
    setSingleStoredData('selectFilterData', updateSelectedTab);
  }, []);

  // Navigate
  const navigate = useNavigate();
  const checkLoggedInUser = useSelector(loggedUser);
  const isAdminLoggedIn = checkLoggedInUser.user.user_auth_type == 'admin' ? true : false;
  const loggedInUserId = checkLoggedInUser.user.user_id;

  // States
  const [data, setData] = useState([]);
  const [routeName, setRouteNames] = useState([]);
  const [time, setTotalTime] = useState('');
  const [showEditPunchModal, setShowEditPunchModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    getStoredDataUsingKey(storageKey, 'currentPage', 1)
  );

  const [paginationData, setPaginationData] = useState(null);

  const [selectedStatus, setSelectedStatus] = useState(
    getStoredDataUsingKey(storageKey, 'selectedStatus', '')
  );

  const [selectedFilterTab, setSelectedFilterTab] = useState(
    getStoredDataUsingKey(storageKey, 'selectedFilterTab', 'today')
  );
  const [biometricApprovers, setBiometricApprovers] = useState([]);

  const [selectedDateRange, setSelectedDateRange] = useState(
    getStoredDataUsingKey(storageKey, 'selectedDateRange', '')
  );

  const [searchText, setSearchText] = useState(getStoredDataUsingKey(storageKey, 'searchText', ''));

  const [fromDate, setFromDate] = useState(getStoredDataUsingKey(storageKey, 'fromDate', null));
  const [toDate, setToDate] = useState(getStoredDataUsingKey(storageKey, 'toDate', null));

  // Setting Data Initialization
  useBioMetricSetting(
    ({ data: setting }) => {
      setBiometricApprovers(setting?.biometric_approvers?.split(',') ?? '');
    },
    (error) => {
        onDefaultError(error);
    }
  );

  // Update BioMetric API Call
  const { mutate: doUpdateBioMetric, isLoading: UpdateBioMetricLoading } = useUpdateBioMetric(
    (response) => {
      toast.success(response.message);
      formikEditPunchInout.resetForm();
      setShowEditPunchModal(false);
      refetchOwnData();
    },
    (error) => {
      toast.error(error.message);
    }
  );

  const today = moment().format('YYYY-MM-DD');

  const formikEditPunchInout = useFormik({
    initialValues: {
      id: '',
      punch_date: '',
      time: '',
      user_notes: '',
      previous_punch_timestamp: `${today} 00:00:00`,
      next_punch_timestamp: `${today} 23:59:59`,
      punch_time: ''
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const date = new Date(values.punch_date + ' ' + values.time);

      // Get formatted ISO string with hours in 24-hour format
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      values.punch_time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      doUpdateBioMetric(values);
    }
  });

  // Status option
  const status = [
    { value: '1', label: `${t('page.punch_in_out_status_success')}` },
    { value: '2', label: `${t('page.punch_in_out_status_error')}` },
    { value: '3', label: `${t('page.punch_in_out_status_pending')}` },
    { value: '4', label: `${t('page.punch_in_out_status_accepted')}` },
    { value: '5', label: `${t('page.punch_in_out_status_rejected')}` }
  ];

  const handleEditPunchInClose = () => {
    setShowEditPunchModal(false);
    formikEditPunchInout.resetForm();
  };

  // clear search button
  const handleClearFilter = () => {
    setSelectedStatus('');
    setSearchText('');
    setCurrentPage(1);
    setFromDate(null);
    setToDate(null);
    removeStoredData(storageKey);
  }; 

  const getStatusWithColor = (punch_in_out_status) => {
    let temp_obj = {
      statusText: '',
      textColor: ''
    };
    switch (punch_in_out_status) {
      case 1:
        temp_obj.statusText = `${t('page.punch_in_out_status_success')}`;
        temp_obj.textColor = 'green';
        break;
      case 2:
        temp_obj.statusText = `${t('page.punch_in_out_status_error')}`;
        temp_obj.textColor = 'red';
        break;
      case 3:
        temp_obj.statusText = `${t('page.punch_in_out_status_pending')}`;
        temp_obj.textColor = 'orange';
        break;
      case 4:
        temp_obj.statusText = `${t('page.punch_in_out_status_approved')}`;
        temp_obj.textColor = 'blue';
        break;
      case 5:
        temp_obj.statusText = `${t('page.punch_in_out_status_rejected')}`;
        temp_obj.textColor = 'red';
        break;
    }

    return temp_obj;
  };

  // Action Handlers

  const handleViewClick = (tdata) => {
    let id = tdata.currentTarget.getAttribute('id');
    navigate(`/punch-in-out/view/${id}`);
  };

  const handleEditClick = (tdata) => {
    let id = tdata.currentTarget.getAttribute('id');
    navigate(`/punch-in-out/edit/${id}`);
  };

  // Route
  useRouteAccessList((res) => {
    setRouteNames(res.data.route_name);
  });
  const shouldShowRoute = (route) => {
    if (routeName) {
      return routeName.includes(route);
    }
  };

  // pending record edit format
  const pendingRecordUpdate = (data) => {
    // Pending record selected value
    if (data.status == 3) {
      if (data.punch_time) {
        let punch_date = moment(data.punch_time, 'Do MMMM YYYY, h:mm:ss A').format('YYYY-MM-DD');
        let time = moment(data.punch_time, 'Do MMMM YYYY, h:mm:ss A').format('hh:mm:ss A');
        formikEditPunchInout.resetForm({
          values: {
            ...formikEditPunchInout.values,
            id: data.biometric_id,
            previous_punch_timestamp: data.previous_punch_timestamp || '',
            next_punch_timestamp: data.next_punch_timestamp || '',
            punch_date: punch_date || '',
            time: time || '',
            user_notes: data.user_notes || '',
          }
        });
      } else {
        formikEditPunchInout.resetForm({
          values: {
            ...formikEditPunchInout.values,
            id: data.biometric_id,
            punch_date: '',
            time:'',
            user_notes: '',
          }
        });
      }
    }
  };
  // pending record edit format

  // Filter Initialization
  useEffect(() => {
    let ownPunchInOut = {
      searchText: searchText,
      currentPage: currentPage,
      selectedStatus: selectedStatus,
      selectedEmployee: getStoredDataUsingKey(storageKey, 'selectedEmployee', ''),
      selectedMachineName: getStoredDataUsingKey(storageKey, 'selectedMachineName', ''),
      selectedPunchType: getStoredDataUsingKey(storageKey, 'selectedPunchType', ''),
      fromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : '',
      toDate: toDate ? moment(toDate).format('YYYY-MM-DD') : '',
      selectedFilterTab: selectedFilterTab
    };

    setAllStoredData(storageKey, ownPunchInOut, false);
  }, [currentPage, selectedStatus, fromDate, toDate, selectedFilterTab]);

  // Fetch Attendance Records
  const { refetch: refetchOwnData } = useOwnListPunchInOut(
    [
      currentPage,
      selectedStatus || '',
      selectedFilterTab,
      fromDate ? moment(fromDate).format('YYYY-MM-DD') : '',
      toDate ? moment(toDate).format('YYYY-MM-DD') : ''
    ],
    (res) => {
      if (res.data.punch_in_out_list.length === 0 && currentPage > 1) {
        setPageMoveToFirstPage(setCurrentPage, storageKey);
      }
      setData(res.data?.punch_in_out_list);
      setTotalTime(res.data?.time);
      setPaginationData(res.data?.pagination);
    }
  );

  useEffect(() => {
    setSelectedFilterTab(updateSelectedTab);
    setSingleStoredData('selectFilterData', updateSelectedTab);

    const currFromDate = getStoredDataUsingKey(storageKey, 'fromDate', null);
    const currToDate = getStoredDataUsingKey(storageKey, 'toDate', null);
    setFromDate(currFromDate ? new Date(currFromDate) : null);
    setToDate(currToDate ? new Date(currToDate) : null);
    setCurrentPage(getStoredDataUsingKey(storageKey, 'currentPage', 1));
    setSelectedStatus(getStoredDataUsingKey(storageKey, 'selectedStatus', ''));
    setSearchText(getStoredDataUsingKey(storageKey, 'searchText', ''));
  }, [updateSelectedTab]);

  // const handleDateRangeChange = (event, picker) => {
  //   setSelectedDateRange(
  //     picker.startDate.format('DD-MM-YYYY') + ' - ' + picker.endDate.format('DD-MM-YYYY')
  //   );
  // };
  // const handleClearDate = () => {
  //   setSelectedDateRange('');
  // };

  // Table Action Columns
  const actionColumn = {
    Header: `${t('page.punch_in_out_status_label')}`,
    accessor: 'biometric_id',
    disableSortBy: true,
    Cell: ({ value: initialValue, row }) => {
      let in_status = getStatusWithColor(row.original.in_status);
      let out_status = getStatusWithColor(row.original.out_status);

      return (
        <Stack className="gap-1">
          {row?.original?.is_in === 1 && (
            <>
              <div className={`status-label ${in_status.textColor}`}>{in_status.statusText} </div>
            </>
          )}

          {row?.original?.is_out === 1 && (
            <>
              <div className={`status-label ${out_status.textColor}`}>{out_status.statusText} </div>
            </>
          )}
        </Stack>
      );
    }
  };
  const actionColumnForAll = {
    Header: `${t('page.action_column')}`,
    accessor: 'biometric_id',
    disableSortBy: true,
    Cell: ({ value: initialValue, row }) => {
      let actionButton = [];
      // Check the conditions in sequence
      if (shouldShowRoute('biometric.index') && [3, 4, 5].includes(row.original.status)) {
        actionButton.push(
          <TNButton
            className="table-button view-btn"
            id={initialValue}
            onClick={(event) => handleViewClick(event, initialValue)}>
            <img src={`admin/${viewIcon}`} />
          </TNButton>
        );
      }
      if (
        (row.original.status === 3 || row.original.status === 2 || row.original.status === 5) &&
        (isAdminLoggedIn ||
          loggedInUserId === row.original.user.user_id ||
          shouldShowRoute('biometric.update') ||
          biometricApprovers.includes(String(loggedInUserId)))
      ) {
        actionButton.push(
          <TNButton
            className="table-button edit-btn"
            id={initialValue}
            onClick={(event) => {
                setShowEditPunchModal(true);
                formikEditPunchInout.resetForm({
                  values: {
                    ...formikEditPunchInout.values,
                    id: row?.original?.biometric_id || '',
                    previous_punch_timestamp : row?.original?.previous_punch_timestamp || '',
                    next_punch_timestamp : row?.original?.next_punch_timestamp || new Date(),
                  }
                });
                
              pendingRecordUpdate(row?.original);
            }}>
            <img src={`admin/${editIcon}`} />
          </TNButton>
        );
      }
      if (isAdminLoggedIn || shouldShowRoute('biometric.destroy')) {
        actionButton.push(
          <TNButton
            className="table-button delete-btn"
            id={initialValue}
            onClick={handleDeleteClick.bind(this)}>
            <img src={`admin/${deleteIcon}`} />
          </TNButton>
        );
      }
      // Render the actionButton if it's not null
      return (
        <div className="d-flex align-items-center" style={{ minHeight: 'inherit', gap: '12px' }}>
          {actionButton?.length > 0 ? actionButton : '-'}
        </div>
      );
    }
  };

  // Remove Department
  const { mutate: doDelete } = useDeleteBioMetric(
    (res) => {
      toast.success(res.message);
      refetchOwnData();
    },
    (err) => {
      toast.error(err.message);
    }
  );

  const handleDeleteClick = (tdata) => {
    let id = tdata.currentTarget.getAttribute('id');
    alert({
      type: 'warning',
      title: 'Confirmation',
      message: t('page.delete_alert_popup_message'),
      confirmText: t('page.alert_popup_yes_button'),
      cancelText: t('page.alert_popup_no_button'),
      onConfirm: () => {
        const values = {};
        values.id = id;
        doDelete(values);
      }
    });
  };

  let showActionColumn = true;
  let showActionColumnForAll =
    shouldShowRoute('biometric.index') ||
    shouldShowRoute('biometric.update') ||
    shouldShowRoute('biometric.destroy');

  // Table Columns
  const columnsJson = [
    {
      Header: `${t('page.punch_in_out_time')}`,
      accessor: 'is_same_day',
      disableSortBy: true,
      Cell: ({ row }) => {
        if (
          row.original.is_same_day ||
          (row.original.in_time != '' && row.original.out_time == '')
        ) {
          return (
            <Stack>
              <span style={{ fontSize: '14px', fontWeight: '500', color: '#888888' }}>
                {row.original.in_date}
              </span>
              <span style={{ fontSize: '14px', fontWeight: '500', color: '#171C26' }}>
                {row.original.in_time}{' '}
                {row.original.out_time != '' ? '-' + row.original.out_time : '-'}
              </span>
            </Stack>
          );
        } else {
          return row.original.out && row.original.out != '' ? (
            <div>
              {row.original.in} - <br /> {row.original.out}
            </div>
          ) : (
            <div>{row.original.in}</div>
          );
        }
      }
    },
    {
      Header: `${t('page.punch_in_out_duration')}`,
      accessor: 'duration',
      disableSortBy: true,
      Cell: ({ row }) => {
        return <div className="111">{row.original.duration}</div>;
      }
    },
    {
      Header: `${t('page.punch_in_out_employee')}`,
      accessor: 'employee',
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <div>
            <p>
              {row.original?.user?.user_id ? (
                <>
                  {row.original.user.full_name} | <span>{row.original.employee_code} </span>
                  {row.original?.user?.user_status == 0 && (
                    <span className="text-danger"> [Inactive]</span>
                  )}
                  {row.original?.isUserDeleted && <span className="text-danger"> [Deleted]</span>}
                </>
              ) : (
                <>
                  <span>{row.original.employee_code} </span>
                </>
              )}
            </p>
          </div>
        );
      }
    },

    {
      Header: `${t('page.punch_in_out_machine_name')}`,
      accessor: 'machine_name',
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <div>
            {row.original.in_machine_name} <br /> {row.original.out_machine_name}
          </div>
        );
      }
    },
    {
      Header: `${t('page.punch_in_out_machine_status')}`,
      accessor: 'machine_status',
      disableSortBy: true,
      Cell: ({ row }) => {
        if (row.original.is_both) {
          return (
            <Stack className="gap-1">
              <span className="status-label green">IN</span>
              <span className="status-label red">OUT</span>
            </Stack>
          );
        } else {
          return (
            <Stack className="gap-1">
              <span
                className={
                  row.original.in_out_text == 'In' ? 'status-label green' : 'status-label red'
                }>
                {row.original.in_out_text}
              </span>
            </Stack>
          );
        }
      }
    }
  ];

  // Table Columns
  const columnsJsonForAll = [
    {
      Header: `${t('page.punch_in_out_time')}`,
      accessor: 'punch_time',
      disableSortBy: true,
      Cell: ({ row }) => {
        return <div>{row.original.punch_time ? row.original.punch_time : '-'}</div>;
      }
    },
    {
      Header: `${t('page.punch_in_out_employee')}`,
      accessor: 'employee',
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <div>
            <p>
              {row.original?.user?.user_id ? (
                <>
                  {row.original.user.full_name} | <span>{row.original.employee_code} </span>
                  {row.original?.user?.user_status == 0 && (
                    <span className="text-danger"> [Inactive]</span>
                  )}
                  {row.original?.isUserDeleted && <span className="text-danger"> [Deleted]</span>}
                </>
              ) : (
                <>
                  {biometricApprovers.includes(loggedInUserId) || isAdminLoggedIn ? (
                    <TNButton
                      onClick={() => {
                        formikUserAssign.setFieldValue('id', row?.original?.biometric_id || '');
                        setShowModal(true);
                      }}
                      name={row?.original?.user?.user_id}
                      className="table-primary-button btn-sm">
                      {t('page.action_button_text_update_user')}
                    </TNButton>
                  ) : (
                    <></>
                  )}
                  <span>{row.original.employee_code} </span>
                </>
              )}
            </p>
          </div>
        );
      }
    },

    {
      Header: `${t('page.punch_in_out_machine_name')}`,
      accessor: 'machine_name',
      disableSortBy: true,
      Cell: ({ row }) => {
        return <div>{row.original.machine_name}</div>;
      }
    },
    {
      Header: `${t('page.punch_in_out_machine_status')}`,
      accessor: 'machine_status',
      disableSortBy: true,
      Cell: ({ row }) => {
        // return <div>{row.original.machine_status}</div>;
        return (
          <div>
            <span
              className={
                row.original.machine_status == 'In' ? 'status-label green' : 'status-label red'
              }>
              {row.original.machine_status}
            </span>
          </div>
        );
      }
    },
    {
      Header: `${t('page.punch_in_out_status_label')}`,
      accessor: 'status',
      disableSortBy: true,
      Cell: ({ value: initialValue, row }) => {
        let statusText = '';
        let textColor = '';
        switch (row?.original?.status) {
          case 1:
            statusText = `${t('page.punch_in_out_status_success')}`;
            textColor = 'green';
            break;
          case 2:
            statusText = `${t('page.punch_in_out_status_error')}`;
            textColor = 'red';
            break;
          case 3:
            statusText = `${t('page.punch_in_out_status_pending')}`;
            textColor = 'orange';
            break;
          case 4:
            statusText = `${t('page.punch_in_out_status_approved')}`;
            textColor = 'blue';
            break;
          case 5:
            statusText = `${t('page.punch_in_out_status_rejected')}`;
            textColor = 'red';
            break;
          default:
            statusText = '';
            break;
        }
        return <div className={`status-label ${textColor}`}>{statusText}</div>;
      }
    }
  ];

  if (showActionColumnForAll) {
    columnsJsonForAll.push(actionColumnForAll);
  }
  const columnsForAll = useMemo(() => columnsJsonForAll, [routeName]);

  if (showActionColumn) {
    columnsJson.push(actionColumn);
  }
  const columns = useMemo(() => columnsJson, [routeName]);
  if (paginationData === null) {
    return null;
  }
  // Pagination And Filters
  const pageIndexHandle = (pageIndex) => {
    setCurrentPage(pageIndex + 1);
  };

  // Cancel Form
  const handleCancel = () => {
    if (formikEditPunchInout.dirty && formikEditPunchInout.dirty !== undefined) {
      alert({
        type: 'warning',
        title: 'Confirmation',
        message: t('page.reset_alert_popup_message'),
        confirmText: t('page.alert_popup_yes_button'),
        cancelText: t('page.alert_popup_no_button'),
        onConfirm: () => {
          setShowEditPunchModal(false);
          formikEditPunchInout.resetForm();
        }
      });
    } else {
      setShowEditPunchModal(false);
      formikEditPunchInout.resetForm();
    }
  };

  return (
    <>
      <CommonSEOTitle title={t('page.punch_in_out_list_label')} />
      <Stack className="punch-in-out-filter-wrapper align-items-center flex-row flex-wrap filter-row">
        <Select
          classNamePrefix="custom-select-prefix"
          isClearable={true}
          placeholder={t('page.select_status')}
          options={status}
          value={status.filter((option4) => option4.value == selectedStatus)}
          onChange={(selectedOption) => {
            setCurrentPage(1);
            if (selectedOption !== null) {
              setSelectedStatus(selectedOption.value);
            } else {
              setSelectedStatus('');
            }
          }}
        />

        {selectedFilterTab && selectedFilterTab == 'all' && (
          <>
            <div className="d-flex align-items-center gap-2 date-wrapper-with-text">
              <span className="date-label">From</span>
              <div
                className="date-range-wrapper"
                style={{ position: 'relative', cursor: 'pointer' }}
                onClick={() => inputRef.current?.setFocus()} // open datepicker on full area click
              >
                <DatePicker
                  isClearable={true}
                  selected={fromDate != '' && fromDate != null ? new Date(fromDate) : null}
                  onChange={(date) => setFromDate(date)}
                  maxDate={toDate != '' && toDate != null ? new Date(toDate) : new Date()}
                  placeholderText={t('page.date_placeholder')}
                  dateFormat="dd-MM-yyyy"
                  customInput={
                    <input
                      ref={inputRef}
                      className="form-control date-filter no-calendar-icon"
                      style={{ width: '100%' }}
                    />
                  }
                />
                <span
                  style={{
                    position: 'absolute',
                    top: '50%',
                    right: '10px',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                    zIndex: 1
                  }}>
                  <img src={'/admin' + DateIcon} width={16} height={16} alt="calendar icon" />
                </span>
              </div>
            </div>

            <div className="d-flex align-items-center gap-2 date-wrapper-with-text">
              <span className="date-label">To</span>
              <div
                className="date-range-wrapper"
                style={{ position: 'relative', cursor: 'pointer' }}
                onClick={() => toDateRef.current?.setFocus()}>
                <DatePicker
                  isClearable={true}
                  selected={toDate != '' && toDate != null ? new Date(toDate) : null}
                  onChange={(date) => setToDate(date)}
                  minDate={fromDate}
                  maxDate={new Date()}
                  placeholderText={t('page.date_placeholder')}
                  dateFormat="dd-MM-yyyy"
                  customInput={
                    <input
                      ref={toDateRef}
                      className="form-control date-filter no-calendar-icon"
                      style={{ width: '100%' }}
                      name="to"
                    />
                  }
                />
                <span
                  style={{
                    position: 'absolute',
                    top: '50%',
                    right: '10px',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                    zIndex: 1
                  }}>
                  <img src={'/admin' + DateIcon} width={16} height={16} alt="calendar icon" />
                </span>
              </div>
            </div>
          </>
        )}

        <Button
          type="button"
          onClick={handleClearFilter}
          className="cancel-search-btn"
          disabled={
            !(selectedFilterTab === 'all'
              ? searchText || fromDate || toDate || selectedStatus
              : searchText || selectedStatus)
          }>
          <img src={`admin/${CloseIcon}`} />
          {t('page.cancel_search_button')}
        </Button>

        {(selectedFilterTab === 'all' && (fromDate || toDate)) || selectedFilterTab !== 'all' ? (
          time && time !== 'Error' ? (
            <div className="d-flex justify-content-between align-items-center ms-auto">
              <div className="total-time-wrapper d-flex align-items-center gap-2">
                {t('page.punch_in_out_total_time_label')}
                <div
                  className={time.includes('Error') ? 'status-label red' : 'status-label blue'}
                  style={{ minHeight: 'inherit', textTransform: 'capitalize' }}>
                  {time}
                </div>
              </div>
            </div>
          ) : null
        ) : null}
      </Stack>

      <TNTable
        columns={selectedFilterTab == 'all' ? columnsForAll : columns}
        data={data}
        paginationData={paginationData}
        onSelectPage={pageIndexHandle}
        t={t}
        pageIndexGet={currentPage - 1}
        key={Math.floor(Math.random() * (1000 - 1 + 1) + 1)}
      />

      {/* Biometric update record */}
      <Modal show={showEditPunchModal} onHide={handleEditPunchInClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('page.punch_in_out_edit_label')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mx-auto">
          <Form onSubmit={formikEditPunchInout.handleSubmit}>
            <Form.Group>
              <Form.Label className="field-label field-label-top">
                {t('page.edit_punch_in_out_punch_date_label')}
              </Form.Label>
              <br />
              <DatePicker
                style={{ width: '100%' }}
                isClearable={true}
                dropdownMode="select"
                showMonthDropdown
                showYearDropdown
                adjustDateOnChange
                className="form-control"
                placeholderText={'yyyy-MM-dd'.toUpperCase()}
                selected={
                  formikEditPunchInout.values.punch_date
                    ? new Date(formikEditPunchInout.values.punch_date)
                    : null
                }
                dateFormat="yyyy-MM-dd"
                maxDate={new Date()}
                onChange={(date) => {
                  if (date) {
                    let time = moment(date).format('YYYY-MM-DD');
                    formikEditPunchInout.setFieldValue('punch_date', time);
                  } else {
                    formikEditPunchInout.setFieldValue('punch_date', '');
                  }
                }}
              />
              <div className="form-field-error-text">
                {formikEditPunchInout.touched.punch_date &&
                formikEditPunchInout.errors.punch_date ? (
                  <div>{t(formikEditPunchInout.errors.punch_date)}</div>
                ) : null}
              </div>
            </Form.Group>
            <Form.Group>
              <Form.Label className="field-label field-label-top">
                {t('page.edit_punch_in_out_punch_time_label')}
              </Form.Label>
              <br />
              <DatePicker
                style={{ width: '100%' }}
                isClearable={true}
                dropdownMode="select"
                showMonthDropdown
                showTimeSelect
                timeFormat="hh:mm:ss aa"
                dateFormat="hh:mm:ss aa"
                showTimeSelectOnly
                timeIntervals={1} // Allows selection of every second
                showYearDropdown
                adjustDateOnChange
                className="form-control"
                placeholderText={'HH:MM:SS AM/PM'}
                selected={
                  formikEditPunchInout.values.time
                    ? (() => {
                        const [timePart, period] = formikEditPunchInout.values.time.split(' ');

                        let [hours, minutes, seconds] = timePart.split(':').map(Number);
                        let isPM = false;
                        if (hours > 12) {
                          isPM = true;
                        }
                        if (period) {
                          isPM = period.toLowerCase() === 'pm';
                          if (isPM && hours < 12) hours += 12;
                          if (!isPM && hours === 12) hours = 0; // handle 12 AM correctly
                        }

                        const date = new Date();
                        date.setHours(hours, minutes, seconds, 0, isPM);
                        return date;
                      })()
                    : null
                }
                onChange={(time) => {
                  if (time) {
                    let formattedTime = time.toLocaleTimeString('en-GB', { hour12: false }); // Converts to HH:mm:ss
                    if (formattedTime) {
                      formikEditPunchInout.setFieldValue('time', formattedTime);
                    } else {
                      formikEditPunchInout.setFieldValue('time', '');
                    }
                  } else {
                    formikEditPunchInout.setFieldValue('time', '');
                  }
                }}
              />
              <div className="form-field-error-text">
                {formikEditPunchInout.touched.time && formikEditPunchInout.errors.time ? (
                  <div>{t(formikEditPunchInout.errors.time)}</div>
                ) : null}
              </div>
            </Form.Group>
            <Form.Group>
              <Form.Label className="field-label field-label-top">
                {t('page.edit_punch_in_out_user_notes_label')}
              </Form.Label>
              <br />
              <Form.Control
                as="textarea"
                name="user_notes"
                placeholder={t('page.biometric_note_placeholder')}
                style={{ width: '100%' }}
                onChange={formikEditPunchInout.handleChange}
                onBlur={formikEditPunchInout.handleBlur}
                value={formikEditPunchInout.values.user_notes}
                className="mt-2"
              />
              <div className="form-field-error-text">
                {formikEditPunchInout.touched.user_notes &&
                formikEditPunchInout.errors.user_notes ? (
                  <div>{t(formikEditPunchInout.errors.user_notes)}</div>
                ) : null}
              </div>
            </Form.Group>
            <div className="primary-button">
              <span
                className="link-center"
                onClick={() => {
                  handleCancel();
                }}>
                {t('page.cancel_button_text')}
              </span>
              <TNButton
                type="submit"
                // loading={isLoadingEmail}
                isdirtyform={
                  formikEditPunchInout.dirty && formikEditPunchInout.dirty !== undefined ? 1 : 0
                }>
                {t('page.save_button_text')}
              </TNButton>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* Biometric update record */}
    </>
  );
};
ListPage.propTypes = {
  columns: PropTypes.any,
  data: PropTypes.any,
  paginationData: PropTypes.any,
  t: PropTypes.func,
  row: PropTypes.any,
  value: PropTypes.any
};
export default ListPage;
